import { apiClient } from './api';
import type {
  TenantStudioCategory,
  TenantStudioCategoryPayload,
  TenantStudioLocation,
  TenantStudioLocationPayload,
  TenantStudioSeason,
  TenantStudioSeasonPayload,
  TenantStudioSettings,
} from '../types';

export async function getTenantStudioSettings(): Promise<TenantStudioSettings> {
  const response = await apiClient.get<TenantStudioSettings>('/api/v1/web/studio-settings');
  return response.data;
}

export async function createTenantStudioLocation(payload: TenantStudioLocationPayload): Promise<TenantStudioLocation> {
  const response = await apiClient.post<TenantStudioLocation>('/api/v1/web/studio-settings/locations', payload);
  return response.data;
}

export async function updateTenantStudioLocation(
  locationId: number,
  payload: TenantStudioLocationPayload
): Promise<TenantStudioLocation> {
  const response = await apiClient.patch<TenantStudioLocation>(`/api/v1/web/studio-settings/locations/${locationId}`, payload);
  return response.data;
}

export async function deleteTenantStudioLocation(locationId: number): Promise<void> {
  await apiClient.delete(`/api/v1/web/studio-settings/locations/${locationId}`);
}

export async function createTenantStudioSeason(payload: TenantStudioSeasonPayload): Promise<TenantStudioSeason> {
  const response = await apiClient.post<TenantStudioSeason>('/api/v1/web/studio-settings/seasons', payload);
  return response.data;
}

export async function updateTenantStudioSeason(
  seasonId: number,
  payload: TenantStudioSeasonPayload
): Promise<TenantStudioSeason> {
  const response = await apiClient.patch<TenantStudioSeason>(`/api/v1/web/studio-settings/seasons/${seasonId}`, payload);
  return response.data;
}

export async function deleteTenantStudioSeason(seasonId: number): Promise<void> {
  await apiClient.delete(`/api/v1/web/studio-settings/seasons/${seasonId}`);
}

export async function createTenantStudioCategory(payload: TenantStudioCategoryPayload): Promise<TenantStudioCategory> {
  const response = await apiClient.post<TenantStudioCategory>('/api/v1/web/studio-settings/categories', payload);
  return response.data;
}

export async function updateTenantStudioCategory(
  categoryId: number,
  payload: TenantStudioCategoryPayload
): Promise<TenantStudioCategory> {
  const response = await apiClient.patch<TenantStudioCategory>(`/api/v1/web/studio-settings/categories/${categoryId}`, payload);
  return response.data;
}

export async function deleteTenantStudioCategory(categoryId: number): Promise<void> {
  await apiClient.delete(`/api/v1/web/studio-settings/categories/${categoryId}`);
}
